import type { SearchResult } from 'conversational-search-client';

/** With the image gate off, images fall into the video bucket as they did before the gate existed. */
export function isImageBucketResult(result: SearchResult, supportsImages: boolean): boolean {
    return supportsImages && result.contentClass === 'image';
}

export function isVideoBucketResult(result: SearchResult, supportsImages: boolean): boolean {
    return result.contentClass !== 'audio' && !isImageBucketResult(result, supportsImages);
}
